import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const DateInput = /*@__PURE__*/ proxyCustomElement(class DateInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const localValue = target.value;
            if (this.filterTimeZone) {
                const utcDate = this.convertToUTC(localValue);
                this.inputHandler(this.name, utcDate);
                this.formControlInput.emit({ name: this.name, value: utcDate });
            }
            else {
                this.inputHandler(this.name, localValue);
                this.formControlInput.emit({ name: this.name, value: localValue });
            }
        };
        this.name = undefined;
        this.label = undefined;
        this.inputHandler = undefined;
        this.defaultValue = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.disabled = undefined;
        this.filterTimeZone = false;
        this.showTime = undefined;
    }
    handleDefaultValueChange(newValue) {
        if (this.filterTimeZone) {
            this.updateInput(this.convertToLocal(newValue));
        }
        else {
            this.updateInput(newValue);
        }
    }
    get maxDate() {
        if (!this.showTime) {
            return new Date().toISOString().split('T')[0];
        }
        else {
            return new Date().toISOString().slice(0, 16);
        }
    }
    componentDidLoad() {
        if (this.filterTimeZone) {
            this.updateInput(this.convertToLocal(this.defaultValue));
        }
        else {
            this.updateInput(this.defaultValue);
        }
    }
    updateInput(value) {
        this.dateInput.value = value;
    }
    convertToUTC(value) {
        const dateObj = new Date(value);
        return new Date(dateObj.toUTCString()).toISOString();
    }
    convertToLocal(value) {
        if (!value)
            return value;
        const date = new Date(value);
        // Adjust the date to the local timezone
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return this.showTime ? localDate.toISOString().slice(0, 16) : localDate.toISOString().split('T')[0];
    }
    render() {
        return (h(Host, { key: '2ee850cab24ab7d32cbd638299f59827b5b7e117', exportparts: "label,input,input-invalid" }, h("div", { key: 'cc898cb56cb32f86e9a9f2a8fb626c38394cf36f', class: "form-group d-flex flex-column" }, h("div", { key: 'de4f8f4da4d650eeced126625ddcad480714dc50', class: "d-flex gap-2" }, h("label", { key: '99a74827cb24033d33ce5e9b978c4ec7161590f4', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: 'c9b2278afb165b5fc37dea2546f41912edb21567', helpText: this.helpText })), h("input", { key: 'af22c6198cb66961a3b4acf8486fdf034d65108c', type: this.showTime ? 'datetime-local' : 'date', ref: el => (this.dateInput = el), id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input ${this.errorText && 'input-invalid'}`, class: this.errorText ? 'form-control is-invalid' : 'form-control', disabled: this.disabled, max: this.maxDate }), h("form-control-error-text", { key: 'cdb69d99d1736c8ba976170bb2baf28246939cfd', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-date", {
        "name": [1],
        "label": [1],
        "inputHandler": [16],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "disabled": [4],
        "filterTimeZone": [4, "filter-time-zone"],
        "showTime": [4, "show-time"]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-date", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-date":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, DateInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { DateInput as D, defineCustomElement as d };
